module.exports = __webpack_public_path__ + "static/media/29ADMSPC10.50acc2e4.jpg";